"use client";

import { ReactNode, ButtonHTMLAttributes } from "react";
import { ChevronRight } from "lucide-react";

interface CommandMenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  label: string;
  description?: string;
  shortcut?: string;
  selected?: boolean;
  hasSubmenu?: boolean;
  danger?: boolean;
}

export function CommandMenuItem({
  icon,
  label,
  description,
  shortcut,
  selected = false,
  hasSubmenu = false,
  danger = false,
  className = "",
  ...props
}: CommandMenuItemProps) {
  return (
    <button
      type="button"
      className={`
        w-full flex items-center gap-3 px-3 py-2 text-left
        transition-colors rounded-sm
        ${selected ? "bg-[var(--color-accent-yellow)]/20" : "hover:bg-[var(--color-surface-hover)]"}
        ${danger ? "text-red-600 hover:bg-red-500/10" : "text-[var(--color-text-secondary)]"}
        ${className}
      `}
      {...props}
    >
      {/* Icon */}
      {icon && (
        <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-[var(--color-text-muted)]">
          {icon}
        </span>
      )}

      {/* Label & Description */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium truncate">{label}</div>
        {description && (
          <div className="text-xs text-[var(--color-text-muted)] truncate">{description}</div>
        )}
      </div>

      {/* Shortcut */}
      {shortcut && (
        <span className="text-xs text-[var(--color-text-muted)] font-mono">{shortcut}</span>
      )}

      {/* Submenu indicator */}
      {hasSubmenu && (
        <ChevronRight className="w-4 h-4 text-[var(--color-text-muted)] flex-shrink-0" />
      )}
    </button>
  );
}

export { type CommandMenuItemProps };
